import React, { useState, useEffect } from 'react';
import {object, func, bool, string} from 'prop-types';

import {CloneObject} from '../../../utils/helpers';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {DatePickerCustom, FormError, InputPersona} from '../../common';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {useFormErrors} from '../../hooks/useFormErrors';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {TIPS} from "../../../consts/tips";
import {Accordion, FormLabel, Modal} from "../../common";

const EdesurClienteModal = (props) => {

    const entityInit = {
        id: 0,
        idEdesur: 0,
        idPersona: 0,
        idTipoPersona: 0,
        nombrePersona: "",
        idTipoDocumento: 0,
        numeroDocumento: "",
        codigoCliente: "",
        fechaDesde: null,
        fechaHasta: null,
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
    });
    const [persona, setPersona] = useState({
        idTipoPersona: 0,
        nombrePersona: "",
        idTipoDocumento: 0,
        numeroDocumento: ""
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        setPersona({
            idTipoPersona: props.data.entity.idTipoPersona,
            nombrePersona: props.data.entity.nombrePersona,
            idTipoDocumento: props.data.entity.idTipoDocumento,
            numeroDocumento: props.data.entity.numeroDocumento,
        });
        formSet({
            idPersona: props.data.entity.idPersona,
            codigoCliente: props.data.entity.codigoCliente,
            fechaDesde: props.data.entity.fechaDesde,
            fechaHasta: props.data.entity.fechaHasta
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idPersona: 0,
        codigoCliente: "",
        fechaDesde: null,
        fechaHasta: null
    });

    // Handlers

    const { errorOf, validate } = useFormErrors(getErrors);

    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);

        row.idPersona = parseInt(formValues.idPersona);
        row.idTipoPersona = persona.idTipoPersona;
        row.nombrePersona = persona.nombrePersona;
        row.idTipoDocumento = persona.idTipoDocumento;
        row.numeroDocumento = persona.numeroDocumento;
        row.codigoCliente = formValues.codigoCliente;
        row.fechaDesde = formValues.fechaDesde;
        row.fechaHasta = formValues.fechaHasta;

        props.onConfirm(row);
    };

    // Funciones
    function getErrors() {

        const errors = {};

        if (formValues.idPersona <= 0) errors.idPersona = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.codigoCliente.length <= 0) errors.codigoCliente = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.fechaDesde === null) errors.fechaDesde = VALIDATION_MESSAGE.REQUIRED_DATE;

        return errors;
    }

    return (
            <Modal
                size="lg"
                title={`Cliente: ${(state.entity.id > 0) ? state.entity.codigoCliente : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.EDESUR_CLIENTE_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">
                                <div className="mb-3 col-12">
                                    <Accordion title="Detalle del cliente" startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-8">
                                                <FormLabel htmlFor="idPersona" required>Persona</FormLabel>
                                                <InputPersona
                                                    name="idPersona"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idPersona') ? 'is-invalid' : ''}`}
                                                    value={formValues.idPersona}
                                                    idTipoPersona={0}
                                                    onChange={(event) => {
                                                        const {target} = event;
                                                        const persona = (target.row) ? {
                                                            idTipoPersona: target.row.idTipoPersona,
                                                            idTipoDocumento: target.row.idTipoDocumento,
                                                            numeroDocumento: target.row.numeroDocumento,
                                                            nombrePersona: target.row.nombrePersona
                                                        } : {
                                                            idTipoPersona: 0,
                                                            idTipoDocumento: 0,
                                                            numeroDocumento: "",
                                                            nombrePersona: ""
                                                        };
                                                        setPersona(persona);
                                                        formHandle(event);
                                                    }}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('idPersona')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-4">
                                                <FormLabel htmlFor="codigoCliente" required>Código de
                                                    cliente</FormLabel>
                                                <input
                                                    name="codigoCliente"
                                                    type="text"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('codigoCliente') ? 'is-invalid' : ''}`}
                                                    value={formValues.codigoCliente}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('codigoCliente')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <FormLabel htmlFor="fechaDesde" required>Fecha
                                                    desde</FormLabel>
                                                <DatePickerCustom
                                                    name="fechaDesde"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaDesde') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaDesde}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('fechaDesde')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="fechaHasta" className="form-label">Fecha
                                                    hasta</label>
                                                <DatePickerCustom
                                                    name="fechaHasta"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaHasta}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    minValue={formValues.fechaDesde}
                                                />
                                                <FormError />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>
                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de Cliente"
                                            tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_CLIENTE_EDESUR_MODAL}
                                            processKey={props.processKey}
                                            entidad="EdesurCliente"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>
                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />
    );
}

EdesurClienteModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

EdesurClienteModal.defaultProps = {
    disabled: false
};

export default EdesurClienteModal;